import React from 'react';
import ReactDOM from 'react-dom';

import Routes from '@routes/Routes';

import { KeycloakProvider } from '@react-keycloak/web';
import keycloak from '@security/keycloak';
import { ReactSession } from 'react-client-session';

import ProcessoProvider from '@contexts/ProcessoContext';
import '@sass/style.scss';

ReactSession.setStoreType("cookie");
ReactDOM.render(
	<KeycloakProvider keycloak={keycloak} >
		<ProcessoProvider>
			<Routes />
		</ProcessoProvider>
	</KeycloakProvider>,
	document.getElementById('root')
);
